import { NormalSelectOptions } from "@app/components/select/select.type";
import {
  ACCESS_TOKEN_KEY,
  DEFAULT_DATE_TIME_FORMAT,
  REFRESH_TOKEN_KEY,
  USER_INFO_KEY,
} from "@app/constants";
import StorageService from "@core/services/storage";
import dayjs from "dayjs";

export const clearLocalStorage = () => {
  StorageService.remove(ACCESS_TOKEN_KEY);
  StorageService.remove(REFRESH_TOKEN_KEY);
  StorageService.remove(USER_INFO_KEY);
};

export const formatMoneyVN = (
  money: number | string,
  options?: Intl.NumberFormatOptions
) => {
  return Intl.NumberFormat("vi-VN", options).format(Number(money));
};

export const generatePageList = (totalPage = 0) => {
  return Array(totalPage)
    .fill(0)
    .map((_, index) => ({
      label: String(index + 1),
      value: index + 1,
    })) as NormalSelectOptions;
};

export const fromUnixTime = (unixSeconds: number) => {
  return dayjs.unix(unixSeconds);
};

export const formatDateTime = (
  unixSeconds: number,
  format = DEFAULT_DATE_TIME_FORMAT
) => {
  return fromUnixTime(unixSeconds).format(format);
};

export const convertDate = (
  dateString: dayjs.ConfigType,
  format = DEFAULT_DATE_TIME_FORMAT
) => {
  return dayjs(dateString, format).toDate();
};

export const formatDate = (
  dateString: dayjs.ConfigType,
  format = DEFAULT_DATE_TIME_FORMAT
) => {
  return dayjs(dateString).format(format);
};

export const createObjectURL = (obj: Blob | MediaSource) => {
  return URL.createObjectURL(obj);
};

export const fancyTimeFormat = (duration: number) => {
  // Hours, minutes and seconds
  const hrs = ~~(duration / 3600);
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = "";

  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }

  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;

  return ret;
};

export const escapeFromContent = (text: string) => {
  return text.replace(/ style="([^"]*)"/g, (matched, capture1: string) => {
    const styleArr = capture1.split(";");
    const newStyleArr: string[] = [];

    styleArr.forEach((item) => {
      if (
        item &&
        !item.includes("color") &&
        !item.includes("background-color")
      ) {
        newStyleArr.push(item);
      }
    });

    if (!newStyleArr.length) {
      return matched.replace(matched, "");
    }

    return matched.replace(capture1, `${newStyleArr.join(";")};`);
  });
};

export function numberWithCommas(num: number) {
  // Eg. 1000 -> 1,000
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
